import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedDataService {

  constructor() { }
  private seriesSubject = new Subject<any>();
public series$ = this.seriesSubject.asObservable();
private dataSubject = new Subject<any>();
public data$ = this.dataSubject.asObservable();
private formDataSubject = new Subject<any>();
public formData$ = this.formDataSubject.asObservable();
private specDataSubject = new Subject<any>();
public specData$ = this.specDataSubject.asObservable();
private HpSpecDataSubject = new Subject<any>();
public HpSpecData$ = this.HpSpecDataSubject.asObservable();
private SizeSubject = new Subject<any>();
public SizeData$ = this.SizeSubject.asObservable();
private SizeReducerFeature = new Subject<any>();
public SizeReducerFeatureData$ = this.SizeReducerFeature.asObservable();
private configurationNumber = new Subject<any>();
public configurationNumberData$ = this.configurationNumber.asObservable();
private cadLocation = new Subject<any>();
public cadLocationData$ = this.cadLocation.asObservable();
private cadChangeSubject = new Subject<any>();
public cadChange$ = this.cadChangeSubject.asObservable();
setCADChangeStatus(data: any): void {
  console.log("My CAD change status");
  console.log(data);
  this.cadChangeSubject.next(data);
}
setData(data: any): void {
  this.dataSubject.next(data);
}
setSeries(series: any): void {
  this.seriesSubject.next(series);
}
setAllFormData(formData: any): void {
  console.log(formData);
  this.formDataSubject.next(formData);
}
setHPSpecificationData(HpSpecData: any): void{
  this.HpSpecDataSubject.next(HpSpecData);
}
setHPFanSpecificationData(HpSpecData: any): void{
  this.HpSpecDataSubject.next(HpSpecData);
}
setSize(SizeData:any):void{
  this.SizeSubject.next(SizeData);
}
setSizeToReducerFeature(SizeReducerFeatureData:any, ratio: any, inputSpeed: any, imageUrl:any):void{
 
  this.SizeReducerFeature.next({SizeReducerFeatureData,ratio,inputSpeed,imageUrl});
}
setConfigurationNumber(configurationNumberData:any){
this.configurationNumber.next(configurationNumberData);
console.log(configurationNumberData);
}
setCADLoaction(cadLocationData:any){
  this.cadLocation.next({cadLocationData});
  console.log(cadLocationData);
}
setAllSpecificationData(specData: any): void {
  this.specDataSubject.next(specData);
  console.log("Data Saved");
  console.log(specData);
}
private form1DataSubject = new BehaviorSubject<any>({
  selectedInputPower: null,
  selectedUnits: null,
  selectedRatio: null,
  selectedSpeed: null,
  selectedDutyCycle: null,
  selectedServiceFactor: null,
  selectedOutputSpeed: null
});


form1Data$ = this.form1DataSubject.asObservable();

setFormData(data: any): void {
  this.form1DataSubject.next(data);
}

getFormData() {
  return this.form1DataSubject.asObservable();
}





private SeriesSubject = new BehaviorSubject<any>({
  series: null
});

seriesData$ = this.SeriesSubject.asObservable();

setSeriesData(data: any): void {
  this.SeriesSubject.next(data);
}

getSeriesData() {
  return this.SeriesSubject.asObservable();
}


getCookie(name:string) {
  const cookies = document.cookie.split('; ');
  for (const cookie of cookies) {
    const [key, value] = cookie.split('=');
    if (key === name) return decodeURIComponent(value);
  }
  return null;
}
}
